import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-up-icon',
  templateUrl: './navigation-arrow-up.component.html'
})
export class NavigationArrowUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
